import React, { useRef, useState } from 'react'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography,
  FormControlLabel, Checkbox, Box
} from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet'
import DialogTitleHeaderComponent from './dialog-title-header.component'
import Draggable from 'react-draggable'

interface IProps {
  open: boolean
  handleClose: any
  handleGenerate: (includeOnboardingHeader: boolean, interweaveScribe: boolean) => void
  classes: ClassNameMap
}

const GenerateNoteOptionsDialogComponent: React.FC<IProps> = ({ open, handleClose, handleGenerate, classes }) => {
  const [isGenerating, setIsGenerating] = useState(false)
  const [includeOnboardingHeader, setIncludeOnboardingHeader] = useState(false)
  // Default ON: when a scribe transcript exists it is woven into the narrative note.
  // Uncheck to fall back to the simpler structured note.
  const [interweaveScribe, setInterweaveScribe] = useState(true)
  const dialogRef = useRef(null) as any

  const handleGenerateClick = () => {
    setIsGenerating(true)
    handleGenerate(includeOnboardingHeader, interweaveScribe)
  }

  return (
    <Draggable ref={dialogRef} defaultPosition={{ x: 80, y: 20 }} handle='.generate-note-options-dialog'>
      <Dialog
        id={`generate-note-options-id`}
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        hideBackdrop
        disableScrollLock
        sx={{
          position: "absolute",
          left: '10rem',
          top: '0rem'
        }}
        onKeyUp={(e) => {
          e.preventDefault();
          if (e.key === 'Enter' && !isGenerating) handleGenerateClick()
        }}
      >
        <DialogTitle className={classes.questionHeaderSection} classes={{ root: 'generate-note-options-dialog' }}>
          <DialogTitleHeaderComponent
            title={'Generate Encounter Note'}
            handleDialogClose={handleClose}
          />
        </DialogTitle>
        {isGenerating && <LinearProgress />}
        <DialogContent sx={{ padding: '1rem !important' }}>
          <Typography className={classes.subHeaderTitle} variant='subtitle1'>
            Configure note generation options:
          </Typography>
          <Box sx={{ mt: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeOnboardingHeader}
                  onChange={(e) => setIncludeOnboardingHeader(e.target.checked)}
                  size="small"
                />
              }
              label={
                <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                  Include Optum onboarding header (for initial referral letters)
                </Typography>
              }
            />
          </Box>
          <Box sx={{ mt: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={interweaveScribe}
                  onChange={(e) => setInterweaveScribe(e.target.checked)}
                  size="small"
                />
              }
              label={
                <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                  Interweave scribe narrative (uncheck for a simpler structured note)
                </Typography>
              }
            />
          </Box>
        </DialogContent>
        <DialogActions className={classes.cardLabInfo}>
          <Button
            variant="outlined"
            disabled={isGenerating}
            size="small"
            onClick={handleGenerateClick}
          >
            Generate
          </Button>
          <Button variant="outlined" size="small" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Draggable>
  )
}

export default withStyles(stylesheet)(GenerateNoteOptionsDialogComponent)
